/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = {
  updateProductPrice: (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductPrice", {
      name: "Modify Product Price HTML - #187725",
      enabled: true,
      apply: () => ({
        beforeInit(element) {},
        afterInit(element) {},
        render(elementModel, currentRenderElement) {
          const product = elementModel.getParentElm().getParentElm().getParams()
            .props.product;
          const productTags = product.tags;
          const productCollection = product.collections;
          let hasCustom = false;
          for (let index = 0; index < productTags.length; index++) {
            if (productTags[index].includes("Custom")) {
              hasCustom = true;
            }
            if (productTags[index].includes("custom")) {
              hasCustom = true;
            }
          }
          if (hasCustom) {
            return "POA";
          } else {
            return currentRenderElement;
          }
        },
        beforeRender(element) {},
        afterRender(element) {},
      }),
    });
  },
  hideProductPriceOnSearchBar: (componentRegistry) => {
    componentRegistry.useComponentPlugin("SearchProductItem", {
      name: "Modify Product Price HTML - #199680",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            // Start customization--------------------------------------------
            const productData = element.getParams().props.product;
            const productId = productData.id;
            if (productData?.split_product) {
              productId = productData.variant_id;
            }
            const productItem = document.querySelector(
              '[data-id="' + productId + '"]'
            );
            if (productItem) {
              if (
                productData.tags.filter((item) => item.indexOf("Custom") !== -1).length > 0 ||
                productData.tags.filter((item) => item.indexOf("custom") !== -1).length > 0
              ) {
                const price = productItem.querySelector('.boost-sd__format-currency')
                price.innerHTML = "POA"
              }
            }
            // End-------------------------------------------------------------
          } catch (error) {
            console.log(error);
          }
        },
      }),
    });
  },
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.updateProductPrice,
  customize.hideProductPriceOnSearchBar
]);
